"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBasicHeaders = exports.getAuthHeaders = exports.USER = exports.JSON_SEND = exports.JSON_GET = exports.JSON_BOTH = void 0;
var _btoaLite = _interopRequireDefault(require("btoa-lite"));
const JSON_GET = exports.JSON_GET = {
  Accept: "application/json"
};
const JSON_SEND = exports.JSON_SEND = {
  "Content-Type": "application/json"
};
const JSON_BOTH = exports.JSON_BOTH = {
  ...JSON_GET,
  ...JSON_SEND
};

// noinspection SpellCheckingInspection
const USER = exports.USER = "5433ecccaff67";
const makeAuthHeader = token => `Basic ${(0, _btoaLite.default)(`${USER}:${token}`)}`;
const getBasicHeaders = () => ({
  ...JSON_BOTH,
  Authorization: makeAuthHeader("")
});
exports.getBasicHeaders = getBasicHeaders;
const getAuthHeaders = token => ({
  ...JSON_BOTH,
  Authorization: makeAuthHeader(token)
});
exports.getAuthHeaders = getAuthHeaders;